<div class="auth-page">
    <div class="auth-content">
        <div class="row">
            <div class="col-2">
                <img  style="width: 22px; height: 22px; position: relative; top: 20px; left: 20px;" (click)="this.back()" src="/assets/images/shared/back.svg">

            </div>
            <div class="col-10">
                <img  src="/assets/images/shared/logo.png" style="width: 90px; position: relative; right: 30px; height: 55px; display: block; margin: auto;" alt="">
            </div>
        </div>
        <h1 style="font-weight: bold;">{{  this.pageDetails().title }}</h1>
        <form [formGroup]="this.loginInfo">
            <input type="text" class="form-control" formControlName="email" (input)="this.trim($event.target)" [placeholder]="this.pageDetails().email" aria-label="Username" aria-describedby="basic-addon1">
            <div style="display: -webkit-box; width: 90%; margin: auto;">
                <input style="width: 100%;" matInput [type]="hide ? 'text': 'password'" class="form-control" formControlName="password" [placeholder]="this.pageDetails().password"  aria-label="Username" aria-describedby="basic-addon1">
                <i style="position: relative; top: 10px; right: 40px;" class="material-icons" matSuffix (click) = "hide = !hide">{{hide ? 'visibility':'visibility_off'}}</i>
            </div>
            <a style="color: #0A69EB; margin-bottom: 5px; width: fit-content; position: absolute; right: 5%;"  (click)="this.forgottenPassword()" >{{ this.pageDetails().forgottenPassword }}</a>
        </form>
    </div>
    <div class="auth-actions">
        <p style="color: #ADAFBB; margin-bottom: 5px; ">Все още нямам регистрация. <a  (click)="this.registration()" style="color: #0A69EB;">Регистрирай се</a></p>
        <button [disabled]="!this.loginInfo.touched" type="button" class="btn btn-primary" style="width: 100%; margin: auto;" (click)="this.login()"> {{ this.pageDetails().button }} </button>
    </div>
</div>
<router-outlet></router-outlet>
